<div class="container py-4">
  <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 pb-3 border-bottom">
    <div>
      <span class="badge-provenance mb-2">Personal Lineage Archive</span>
      <h2 class="brand-font mb-1">My Collection & Catalog</h2>
      <p class="text-muted small mb-0">
        Manage your privately owned and exhibited antiques, maintain historical milestones, and control market availability.
      </p>
    </div>

    <a class="btn-antique-gold btn-sm mt-3 mt-md-0" routerLink="/items/list">
      <span class="material-symbols-outlined" style="font-size: 18px;">add_circle</span>
      Catalog New Object
    </a>
  </div>

  <!-- Segmented Tabs -->
  <div class="collection-tabs-nav mb-4">
    <div class="tabs-scroll-container">
      <button type="button" 
              class="collection-tab-btn"
              [class.active]="activeTab === 'collection'"
              (click)="setTab('collection')">
        <span class="material-symbols-outlined tab-icon">museum</span>
        <span class="tab-label">Curated Collection</span>
        <span class="tab-count">{{ collectionItems.length }}</span>
      </button>
      <button type="button" 
              class="collection-tab-btn"
              [class.active]="activeTab === 'selling'"
              (click)="setTab('selling')">
        <span class="material-symbols-outlined tab-icon">storefront</span>
        <span class="tab-label">Listed for Sale</span>
        <span class="tab-count">{{ marketplaceItems.length }}</span>
      </button>
      <button type="button" 
              class="collection-tab-btn"
              [class.active]="activeTab === 'all'"
              (click)="setTab('all')">
        <span class="material-symbols-outlined tab-icon">inventory_2</span>
        <span class="tab-label">All Pieces</span>
        <span class="tab-count">{{ allItems.length }}</span>
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div class="text-center py-5" *ngIf="loading">
    <div class="spinner-border text-secondary" role="status"></div>
    <p class="small text-muted mt-2">Loading your collection records...</p>
  </div>

  <!-- Items Display -->
  <ng-container *ngIf="!loading">
    <!-- Active Tab: Curated Collection -->
    <div *ngIf="activeTab === 'collection'">
      <div class="row g-4" *ngIf="collectionItems.length > 0; else noCollectionState">
        <div class="col-sm-6 col-lg-3" *ngFor="let item of collectionItems">
          <app-simple-card [item]="item"></app-simple-card>
        </div>
      </div>
      <ng-template #noCollectionState>
        <div class="text-center py-6 rounded-3 bg-white border p-5 my-4">
          <span class="material-symbols-outlined text-muted" style="font-size: 54px;">museum</span>
          <h5 class="brand-font mt-3">No Exhibited Collection Pieces</h5>
          <p class="text-muted small" style="max-width: 460px; margin: 0 auto 1.5rem auto;">
            Catalog an heirloom, family artifact, or investment piece to begin building its immutable living provenance without putting it up for sale.
          </p>
          <a class="btn-antique-gold btn-sm" routerLink="/items/list">Catalog an Object</a>
        </div>
      </ng-template>
    </div>

    <!-- Active Tab: Marketplace Listings -->
    <div *ngIf="activeTab === 'selling'">
      <div class="row g-4" *ngIf="marketplaceItems.length > 0; else noSellingState">
        <div class="col-sm-6 col-lg-3" *ngFor="let item of marketplaceItems">
          <app-simple-card [item]="item"></app-simple-card>
        </div>
      </div>
      <ng-template #noSellingState>
        <div class="text-center py-6 rounded-3 bg-white border p-5 my-4">
          <span class="material-symbols-outlined text-muted" style="font-size: 54px;">storefront</span>
          <h5 class="brand-font mt-3">No Pieces Currently Listed for Sale</h5>
          <p class="text-muted small" style="max-width: 460px; margin: 0 auto 1.5rem auto;">
            All your pieces are currently retained in your private exhibition. You can list any piece on the marketplace whenever you are ready.
          </p>
          <button class="btn-antique-outline btn-sm" (click)="setTab('collection')">View Curated Collection</button>
        </div>
      </ng-template>
    </div>

    <!-- Active Tab: All Pieces -->
    <div *ngIf="activeTab === 'all'">
      <div class="row g-4" *ngIf="allItems.length > 0; else noAllState">
        <div class="col-sm-6 col-lg-3" *ngFor="let item of allItems">
          <app-simple-card [item]="item"></app-simple-card>
        </div>
      </div>
      <ng-template #noAllState>
        <div class="text-center py-6 rounded-3 bg-white border p-5 my-4">
          <span class="material-symbols-outlined text-muted" style="font-size: 54px;">inventory_2</span>
          <h5 class="brand-font mt-3">Your Archive is Empty</h5>
          <p class="text-muted small" style="max-width: 460px; margin: 0 auto 1.5rem auto;">
            Begin tracking your antique treasures with certified continuous provenance on Antiqry.
          </p>
          <a class="btn-antique-gold btn-sm" routerLink="/items/list">Catalog First Piece</a>
        </div>
      </ng-template>
    </div>
  </ng-container>
</div>
